import { makeStyles, TablePagination as MUITablePagination } from "@material-ui/core";
import clsx from 'clsx';
import React from 'react';


const useStyles = makeStyles((theme) => ({
    root: {
        color: theme.palette.ascents.systemWhite,
        '& .MuiTablePagination-toolbar': {
            minHeight: 50,
            height: 50,
            backgroundColor: theme.palette.background.default
        },
        '& .MuiTypography-body2': {
            ...theme.typography.body2,
        },

        '& .MuiTablePagination-actions': {
            '& .MuiSvgIcon-root': {
                color: theme.palette.primary.main
            },
            '& .Mui-disabled': {
                '& .MuiSvgIcon-root': {
                    color: theme.palette.ascents.textLightDark,
                },
            }
        }

    },

    pagingSelectInput: {

        color: theme.palette.ascents.textDark,
        ...theme.typography.body2,
        '& > svg': {
            color: theme.palette.ascents.textDark,

        },
        '& > option': {
            color: theme.palette.text.primary,

            ...theme.typography.body1,
        }
    }


}))

const TablePagination = ({ className, ascent = "systemMetalDark", ...props }) => {
    const classes = useStyles({
        ascent
    })
    return (
        <MUITablePagination
            {...props}
            className={clsx(classes.root, classes[`${className}`])}
            SelectProps={{
                inputProps: {
                    "aria-label": "rows per page",
                    className: classes.pagingSelectInput,
                },
                native: true,
                className: classes.pagingSelectInput,
            }}
        />
    );
};

TablePagination.propTypes = {

};

export default TablePagination;